module.exports = __webpack_public_path__ + "media/images/check 2-e5a1dbf02ff4964878e7269259072e70.svg";